import saveUserHighlightService from '../services/saveUserHighlightService';
import markUserHighlight from '../utils/markUserHighlight';
import { logUsage } from 'owa-analytics';
import { ClientItem } from 'owa-mail-store';
import { mutatorAction } from 'satcheljs';

export default mutatorAction(
    'addUserHighlight',
    (element: HTMLElement, item: ClientItem, highlight: string) => {
        const itemUserHighlights: string[] = item.userHighlightData;
        if (itemUserHighlights && itemUserHighlights.indexOf(highlight) == -1) {
            itemUserHighlights.push(highlight);

            // Add user highlight to server
            saveUserHighlightService(item.ItemId.Id, itemUserHighlights);

            // Add user highlight to DOM
            markUserHighlight(element, item, highlight);

            // Log UserHighlightAdded datapoint
            logUsage('UserMarkup_UserHighlightAdded');
        }
    }
);
